module.exports = __webpack_public_path__ + "img/6.65251adb.jpg";